/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MissingPrivilege,
    MissingPrivilegeFromJSON,
    MissingPrivilegeFromJSONTyped,
    MissingPrivilegeToJSON,
} from './MissingPrivilege';
import {
    Privilege,
    PrivilegeFromJSON,
    PrivilegeFromJSONTyped,
    PrivilegeToJSON,
} from './Privilege';

/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof User
     */
    mobileTelephoneNumbers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    credentialOrganizationName?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    credentialSurname?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    credentialGivenName?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    levelOfAssurance?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    commissionPurpose?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    credentialDisplayName?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    organizationName?: string;
    /**
     * 
     * @type {Array<MissingPrivilege>}
     * @memberof User
     */
    missingPrivileges?: Array<MissingPrivilege>;
    /**
     * 
     * @type {Array<string>}
     * @memberof User
     */
    systemRoles?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    healthCareUnitHsaId?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    healthCareProviderHsaId?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    healthCareUnitName?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    healthCareProviderName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof User
     */
    healthcareProfessionalLicense?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    commissionName?: string;
    /**
     * 
     * @type {Array<Privilege>}
     * @memberof User
     */
    privileges?: Array<Privilege>;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    issuer?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    commissionHsaId?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    credentialPersonalIdentityNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    employeeHsaId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof User
     */
    mail?: Array<string>;
}

export function UserFromJSON(json: any): User {
    return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(json: any, ignoreDiscriminator: boolean): User {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'mobileTelephoneNumbers': !exists(json, 'mobileTelephoneNumbers') ? undefined : json['mobileTelephoneNumbers'],
        'credentialOrganizationName': !exists(json, 'credentialOrganizationName') ? undefined : json['credentialOrganizationName'],
        'credentialSurname': !exists(json, 'credentialSurname') ? undefined : json['credentialSurname'],
        'credentialGivenName': !exists(json, 'credentialGivenName') ? undefined : json['credentialGivenName'],
        'levelOfAssurance': !exists(json, 'levelOfAssurance') ? undefined : json['levelOfAssurance'],
        'commissionPurpose': !exists(json, 'commissionPurpose') ? undefined : json['commissionPurpose'],
        'credentialDisplayName': !exists(json, 'credentialDisplayName') ? undefined : json['credentialDisplayName'],
        'organizationName': !exists(json, 'organizationName') ? undefined : json['organizationName'],
        'missingPrivileges': !exists(json, 'missingPrivileges') ? undefined : ((json['missingPrivileges'] as Array<any>).map(MissingPrivilegeFromJSON)),
        'systemRoles': !exists(json, 'systemRoles') ? undefined : json['systemRoles'],
        'healthCareUnitHsaId': !exists(json, 'healthCareUnitHsaId') ? undefined : json['healthCareUnitHsaId'],
        'healthCareProviderHsaId': !exists(json, 'healthCareProviderHsaId') ? undefined : json['healthCareProviderHsaId'],
        'healthCareUnitName': !exists(json, 'healthCareUnitName') ? undefined : json['healthCareUnitName'],
        'healthCareProviderName': !exists(json, 'healthCareProviderName') ? undefined : json['healthCareProviderName'],
        'healthcareProfessionalLicense': !exists(json, 'healthcareProfessionalLicense') ? undefined : json['healthcareProfessionalLicense'],
        'commissionName': !exists(json, 'commissionName') ? undefined : json['commissionName'],
        'privileges': !exists(json, 'privileges') ? undefined : ((json['privileges'] as Array<any>).map(PrivilegeFromJSON)),
        'issuer': !exists(json, 'issuer') ? undefined : json['issuer'],
        'commissionHsaId': !exists(json, 'commissionHsaId') ? undefined : json['commissionHsaId'],
        'credentialPersonalIdentityNumber': !exists(json, 'credentialPersonalIdentityNumber') ? undefined : json['credentialPersonalIdentityNumber'],
        'employeeHsaId': !exists(json, 'employeeHsaId') ? undefined : json['employeeHsaId'],
        'mail': !exists(json, 'mail') ? undefined : json['mail'],
    };
}

export function UserToJSON(value?: User | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'mobileTelephoneNumbers': value.mobileTelephoneNumbers,
        'credentialOrganizationName': value.credentialOrganizationName,
        'credentialSurname': value.credentialSurname,
        'credentialGivenName': value.credentialGivenName,
        'levelOfAssurance': value.levelOfAssurance,
        'commissionPurpose': value.commissionPurpose,
        'credentialDisplayName': value.credentialDisplayName,
        'organizationName': value.organizationName,
        'missingPrivileges': value.missingPrivileges === undefined ? undefined : ((value.missingPrivileges as Array<any>).map(MissingPrivilegeToJSON)),
        'systemRoles': value.systemRoles,
        'healthCareUnitHsaId': value.healthCareUnitHsaId,
        'healthCareProviderHsaId': value.healthCareProviderHsaId,
        'healthCareUnitName': value.healthCareUnitName,
        'healthCareProviderName': value.healthCareProviderName,
        'healthcareProfessionalLicense': value.healthcareProfessionalLicense,
        'commissionName': value.commissionName,
        'privileges': value.privileges === undefined ? undefined : ((value.privileges as Array<any>).map(PrivilegeToJSON)),
        'issuer': value.issuer,
        'commissionHsaId': value.commissionHsaId,
        'credentialPersonalIdentityNumber': value.credentialPersonalIdentityNumber,
        'employeeHsaId': value.employeeHsaId,
        'mail': value.mail,
    };
}

